module.exports = "/virtual-football-league/img/amblems/left/Germany/Fake_Dortmund.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Germany/Fake_Dortmund.png
// module id = 2035
// module chunks = 4